import {
    GET_JOB_PACKS,
    GET_JOB_PACKS2,
    GET_DEPARTMENTS,
    GET_AREAS,
    SET_DATE_FROM,
    SET_DATE_TO,
    SET_FILTER_STATUS,
    SET_DEPARTMENT_STATUS,
    SET_AREA_STATUS,
    SET_SEARCH_JOB_ID,
    SET_PAGE,
    SET_ROW,
    SET_VIEW_TYPE,
    SET_ROW_COUNT,
    SET_PAGE_INDEX,
    SET_SORT_TABLE_TYPE,
    SET_SORT_TABLE_KEY,
    SET_CLICKED_STATUS_JOB_ID,
    SET_MODAL_OPEN,
    MOVE_JOBPACK,
    SET_SNACKBAR_OPEN,
    SET_SORT_TABLE_AS,
    SET_JOB_YEAR,
    SET_JOB_MONTH,
    GET_REGISTERED_USERS,
    SET_TABLE,
    SET_STATUS,
    GET_JOB_PACKSMODAL,
    SET_DAY,
    GET_TEMPLATES,
    SET_FILTER_TEMPLATE,
    TOGGLE_AREAS_DEPT,
    SET_SEARCH_JOB_URN
} from "./types";
import moment from "moment";
import RosterReducer from "./RosterV2/reducer";
import { combineReducers } from "redux";

const INITIAL_STATE = {
    requesting: false,
    jobPacks: false,
    jobPacks2: false,
    dateFrom: false,
    dateTo: false,
    filterStatus: "active",
    departmentType: "all",
    areaType: "all",
    searchVal: "",
    rowCount: 50,
    pageIndex: 0,
    viewType: "list",
    sortTableType: "asc",
    sortTableKey: false,
    sortTableAs: false,
    clickedStatusJobID: false,
    modalOpen: false,
    snackbarOpen: false,
    snackbarStatus: false,
    departments: false,
    areas: false,
    users: false,
    jobYear: moment().format("YYYY"),
    jobMonth: moment()
        .format("MMM")
        .toLowerCase(),
    currentTable: "active",
    statusSet : "active",
    modalData: false,
    day: false,
    templates: false,
    template: false,
    toggleAreasDept : false ,
    jobUrn: ""
};

const MainReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_TEMPLATES.REQUEST:{
            return {...state,requesting: true, templates: false};
        }
        case GET_TEMPLATES.SUCCESS:{
            return {...state,requesting: false, templates: action.payload};
        }
        case GET_TEMPLATES.FAIL: {
            return { ...state, requesting: false, templates: false };
        }
        case GET_REGISTERED_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_REGISTERED_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case GET_REGISTERED_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case SET_SNACKBAR_OPEN: {
            return {
                ...state,
                snackbarOpen: action.payload.value,
                snackbarStatus: action.payload.status
            };
        }
        case SET_MODAL_OPEN: {
            return {
                ...state,
                modalOpen: action.payload
            };
        }
        case SET_CLICKED_STATUS_JOB_ID: {
            return { ...state, clickedStatusJobID: action.payload };
        }
        case SET_ROW_COUNT: {
            return { ...state, rowCount: action.payload };
        }
        case SET_JOB_MONTH: {
            return { ...state, jobMonth: action.payload };
        }
        case SET_JOB_YEAR: {
            return { ...state, jobYear: action.payload };
        }
        case SET_SEARCH_JOB_URN: {
            return { ...state, jobUrn: action.payload };
        }
        
        case SET_FILTER_TEMPLATE: {
            return { ...state, template: action.payload };
        }
        case SET_PAGE_INDEX: {
            return { ...state, pageIndex: action.payload };
        }
        case SET_VIEW_TYPE: {
            return { ...state, viewType: action.payload };
        }
        case SET_SORT_TABLE_TYPE: {
            return { ...state, sortTableType: action.payload };
        }
        case SET_SORT_TABLE_KEY: {
            return { ...state, sortTableKey: action.payload };
        }
        case SET_STATUS: {
            return { ...state, statusSet: action.payload };
        }
        case SET_SORT_TABLE_AS: {
            return { ...state, sortTableAs: action.payload };
        }
        case GET_JOB_PACKS.REQUEST: {
            return { ...state, requesting: true, jobPacks: false };
        }
        case GET_JOB_PACKS.FAIL: {
            return { ...state, requesting: false, jobPacks: false };
        }
        case GET_JOB_PACKS.SUCCESS: {
            return { ...state, requesting: false, jobPacks: action.payload };
        }
        case GET_JOB_PACKS2.REQUEST: {
            return { ...state, requesting: true, jobPacks2: false };
        }
        case GET_JOB_PACKS2.FAIL: {
            return { ...state, requesting: false, jobPacks2: false };
        }
        case GET_JOB_PACKS2.SUCCESS: {
            return { ...state, requesting: false, jobPacks2: action.payload };
        }
        case GET_JOB_PACKSMODAL.REQUEST: {
            return { ...state, requesting: true, modalData: false };
        }
        case GET_JOB_PACKSMODAL.FAIL: {
            return { ...state, requesting: false, modalData: false };
        }
        case GET_JOB_PACKSMODAL.SUCCESS: {
            return { ...state, requesting: false, modalData: action.payload };
        }
        case MOVE_JOBPACK.REQUEST: {
            return { ...state, requesting: true };
        }
        case MOVE_JOBPACK.FAIL: {
            return { ...state, requesting: false };
        }
        case MOVE_JOBPACK.SUCCESS: {
            return { ...state, requesting: false };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                departments: action.payload
            };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }
        case SET_DATE_FROM: {
            return { ...state, dateFrom: action.payload };
        }
        case SET_DATE_TO: {
            return { ...state, dateTo: action.payload };
        }
        case SET_FILTER_STATUS: {
            return { ...state, filterStatus: action.payload };
        }
        case SET_DEPARTMENT_STATUS: {
            return { ...state, departmentType: action.payload };
        }
        case SET_AREA_STATUS: {
            return { ...state, areaType: action.payload };
        }
        case SET_DAY: {
            return { ...state, day: action.payload };
        }
        case SET_SEARCH_JOB_ID: {
            return { ...state, searchVal: action.payload };
        }
        case SET_PAGE: {
            return { ...state, page: action.payload };
        }
        case SET_ROW: {
            return { ...state, rows: action.payload };
        }
        case SET_TABLE: {
            return {
                ...state,
                currentTable: action.payload
            };
        }
        case TOGGLE_AREAS_DEPT: {
            return { ...state, toggleAreasDept: action.payload };
        }
        default: {
            return { ...state };
        }
    }
};

export default combineReducers({
    MainReducer,
    RosterReducer
});
